import axios from "axios";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    getMimeTypeFromExtension(fileName = "") {
      const extension = fileName.split(".").pop()?.toLowerCase();
      const extensionToMimeMap = {
        pdf: "application/pdf",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        webp: "image/webp",
      };
      return extensionToMimeMap[extension] || "";
    },
    getFileNameFromResponse(fileResponse, sourceUrl = "") {
      const disposition = fileResponse?.headers?.["content-disposition"] || "";
      const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (utf8Match?.[1]) {
        return decodeURIComponent(utf8Match[1].replace(/"/g, ""));
      }

      const basicMatch = disposition.match(/filename="?([^";]+)"?/i);
      if (basicMatch?.[1]) {
        return basicMatch[1];
      }

      try {
        const parsedUrl = new URL(sourceUrl, window.location.origin);
        const pathFileName = parsedUrl.pathname.split("/").pop();
        return pathFileName || "preview-file";
      } catch (error) {
        return "preview-file";
      }
    },
    isPreviewableMimeType(mimeType = "") {
      return (
        mimeType.startsWith("image/") ||
        mimeType === "application/pdf" ||
        mimeType.startsWith("text/")
      );
    },
    openPreviewWindow(fileUrl, fileName, mimeType) {
      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        // Popup blocked: fallback to opening the blob directly.
        window.open(fileUrl, "_blank");
        return;
      }

      const escapedFileName = (fileName || "preview-file")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
      const previewBody = this.isPreviewableMimeType(mimeType)
        ? `<iframe src="${fileUrl}" title="${escapedFileName}" style="width:100%;height:calc(100vh - 64px);border:0;"></iframe>`
        : `<div style="padding:24px;font-family:Arial, sans-serif;"><h3 style="margin:0 0 8px;">Preview is not available for this file type.</h3><p style="margin:0;color:#444;">Use the Download button to save and open it locally.</p></div>`;

      previewWindow.document.write(`<!doctype html>
        <html>
          <head>
            <meta charset="utf-8" />
            <title>${escapedFileName}</title>
          </head>
          <body style="margin:0;background:#f5f7fb;">
            <div style="height:64px;display:flex;align-items:center;justify-content:space-between;padding:0 16px;border-bottom:1px solid #d9e1ec;background:#fff;box-sizing:border-box;">
              <div style="font-family:Arial, sans-serif;font-size:14px;color:#0f172a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:75%;">${escapedFileName}</div>
              <a href="${fileUrl}" download="${escapedFileName}" style="font-family:Arial, sans-serif;text-decoration:none;background:#0b5fff;color:#fff;padding:8px 12px;border-radius:6px;font-size:13px;">Download</a>
            </div>
            ${previewBody}
          </body>
        </html>`
      );
      previewWindow.document.close();
    },
    async renameAndDownloadFile(url, filename) {
      const fileResponse = await axios({
        url: url, //your url
        method: "GET",
        responseType: "blob", // important
      });
      url = window.URL.createObjectURL(new Blob([fileResponse.data]));
      const link = document.createElement("a");
      link.href = url;

      if (filename.split(".").pop() !== "pdf") {
        filename = filename + ".pdf";
      }
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    async downloadFileAndPreviewFile(url, openInNewTab = true) {
      const fileResponse = await axios({
        url: url, //your url
        method: "GET",
        responseType: "blob", // important
      });
      const fileName = this.getFileNameFromResponse(fileResponse, url);
      const rawContentType = fileResponse?.headers?.["content-type"] || fileResponse?.data?.type || "";
      const normalizedContentType = rawContentType.split(";")[0].trim().toLowerCase();
      const inferredContentType = this.getMimeTypeFromExtension(fileName);
      const genericMimeTypes = ["", "application/octet-stream", "binary/octet-stream"];
      const finalContentType = genericMimeTypes.includes(normalizedContentType)
        ? inferredContentType || "application/pdf"
        : normalizedContentType;

      const fileBlob = new Blob([fileResponse.data], {
        type: finalContentType,
      });
      url = window.URL.createObjectURL(fileBlob);

      if (openInNewTab) {
        this.openPreviewWindow(url, fileName, finalContentType);
      } else {
        return url;
      }
    },
  },
};
